module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADgAAAA4CAMAAACfWMssAAAAOVBMVEVHcEyqqrOkqrOkqrOkqrOkqrOtrbakqrOkqrOlqrOkq7WkqrOlrLOkqrOkq7Snr7ilqrSkqrOlqrNkWS/nAAAAE3RSTlMAG6bl/+Yc7O2lSeNK4qcd7ueofhWp8QAAAHNJREFUeAHt0TEOgCAMhWGEogoI4P0PK0FN7Na61fTfv+U985u0yTpg5O18uwWYrZfcgJ0d0PGhGxB6hhH0JEJu0uCDOcPIhyHCq5jIsDskv8KdDBOSMYi4Q6FChR7IeQQzHWYES6W6WgyWuVFYO5ATn3YCaHsOlU82zF8AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/change-icon/f0_delivery@2x.png
// module id = WsMG
// module chunks = 0